import { Check, CircleAlert, X } from "lucide-react";
import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

export type FeedbackTone = "success" | "warning";

export function useTransientNotice(timeout = 5200, persistent = false): [string, Dispatch<SetStateAction<string>>] {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!message || persistent) return;
    const timer = window.setTimeout(() => setMessage(""), timeout);
    return () => window.clearTimeout(timer);
  }, [message, persistent, timeout]);

  return [message, setMessage];
}

export function ActionFeedback({
  message,
  tone = "success",
  onDismiss,
  className = "",
}: {
  message: string;
  tone?: FeedbackTone;
  onDismiss: () => void;
  className?: string;
}) {
  const Icon = tone === "warning" ? CircleAlert : Check;
  return (
    <div className={`action-feedback action-feedback-${tone} ${className}`.trim()} role="status">
      <Icon aria-hidden="true" />
      <span>{message}</span>
      <button type="button" onClick={onDismiss} aria-label="关闭操作提示">
        <X aria-hidden="true" />
      </button>
    </div>
  );
}
